export const PERFORMANCE_UPDATE_EVENT_NAME = "performanceTotalsUpdated";
export const MERCH_UPDATE_EVENT_NAME = "merchTotalsUpdated";
export const DONATION_UPDATE_EVENT_NAME = "donationTotalsUpdated";
export const PERFORMANCE_DETAILS_UPDATE_EVENT_NAME = "performanceTotalsUpdated";
